module.exports = __webpack_public_path__ + "static/img-svijet-medija-a4e40ce68fea4ebd65beda63b01bef39.png";